import { Modal } from 'react-bootstrap';
import { BookingRequestRead } from '../../../api';
import { BookingRequestStatusBadge } from '../BookingRequestStatusBadge';

interface DialogHeaderProps {
  bookingRequest: BookingRequestRead;
}

export const DialogHeader = ({ bookingRequest }: DialogHeaderProps) => (
  <Modal.Header closeButton className="bg-neutral-200 tw:!py-2 tw:!my-0">
    <div className="d-flex align-items-start">
      <div>
        <h4 className="pt-1 mb-0">Review Assignment Request</h4>
        {bookingRequest.code && (
          <div className="tw:text-base text-muted">{bookingRequest.code}</div>
        )}
      </div>
      <BookingRequestStatusBadge
        status={bookingRequest.status}
        bookings={bookingRequest.bookings}
        className="ms-3 mt-2"
      />
    </div>
  </Modal.Header>
);
